import { CSSProperties } from 'react'
import { FormattedMessage } from 'react-intl'
import TourButton from './TourButton'
import { useDispatch, useSelector } from 'react-redux'
import { openSignupProcess } from '@app/store/signup/signupSlice'
import { isRegistrationOpen } from '@app/store/tournament/selectors'

interface StateProps {
  style?: CSSProperties
  color?: 'primary' | 'secondary'
  btnText?: React.ReactNode
  disabled?: boolean
  secondaryBtnText?: React.ReactNode
}

type Props = StateProps

const RegisterToTourButton = ({ style, color = 'primary', btnText, secondaryBtnText, disabled }: Props) => {
  const onlineEntriesEnabled = useSelector(
    (state: StoreState) => state.tournamentReducer.tournamentSite.onlineEntriesEnabled,
  )
  const registrationOpen = useSelector(isRegistrationOpen)

  // Don't show if entries are disabled
  // Don't show if entries are not open or entries are closed
  if (!onlineEntriesEnabled) return null

  const dispatch = useDispatch()

  const getButtonText = () => {
    if (color === 'secondary' && secondaryBtnText) {
      return secondaryBtnText
    }
    return btnText ? btnText : <FormattedMessage id={'buttons.signUp'} />
  }

  return (
    <TourButton
      buttonProps={{
        color,
        disabled: disabled ?? (color === 'primary' && !registrationOpen),
        onClick: () => dispatch(openSignupProcess()),
        style: {
          ...style,
          opacity: disabled ?? (color === 'primary' && !registrationOpen) ? 0.5 : 1,
          backgroundColor: color === 'secondary' ? '#fff' : '#098F50',
          color: color === 'secondary' ? '#098F50' : '#fff',
        },
      }}
      variant={color === 'secondary' ? 'outlined' : 'contained'}
    >
      {getButtonText()}
    </TourButton>
  )
}

export default RegisterToTourButton
